import * as React from "react";
import { Kinds } from "constants/product-collection";
import { IPinnedRowsRenderersComponentProps } from "../pinned-row-constants";
import { TotalsRenderersDoorColumn } from "./totals-renderers-door-column";
import { TotalsRenderersLabelColumn } from "./totals-renderers-label-column";
import { PinnedRowOtherColumn } from "../pinned-row-other-column";
import { isDoorColumn } from "helpers/door-collection";

export const getColumnComponent = (
    kind: Kinds,
    fieldName: string
): React.FunctionComponent<IPinnedRowsRenderersComponentProps> => {
    if (kind === Kinds.IMAGE_URL) {
        return TotalsRenderersLabelColumn;
    } else if (
        (kind === Kinds.DOOR_BULK_QUANTITY && isDoorColumn(fieldName)) ||
        kind === Kinds.TOTAL_ALLOCATION_DIMENSIONS
    ) {
        return TotalsRenderersDoorColumn;
    } else {
        return PinnedRowOtherColumn;
    }
};
